import baseRoute from '../baseRoute';

export default `${baseRoute}/organizationNotificationSettings` as const;
